import { Component, ElementRef, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { TranslateService } from '@ngx-translate/core';
import { CdkDrag, CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { cloneControl } from 'app/e-form/helper/script/cloneAbstract';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { MessageBoxComponent } from 'app/shared/message-box/message-box';
import { ValidatorConfigure } from 'app/e-form/config/validator';
import { EditDialogComponent } from '../edit-dialog/edit-dialog.component';
import { HelperTransalaterService } from 'app/e-form/service/helper-translate.service';

@Component({
   selector: 'app-choice-setup',
   templateUrl: './choice-setup.component.html',
   styleUrls: ['./choice-setup.component.scss']
})
export class ChoiceSetupComponent implements OnInit {
   displayedColumns = ['select', 'lang', 'menu'];
   @ViewChildren('input_req') divs: QueryList<ElementRef>;
   langSource = [];  langSupport = [];  tmpDataSource = [];
   defaultValue = this.data.defaultValue;
   validators = new ValidatorConfigure();
   tmpEform: FormArray;
   choiceType = '';  duplicateType = '';
   isEdit = false;
   original = this.data.eForm.controls.original.value;
   private _dynamicIndex = 0;
   dataSource = new MatTableDataSource<any>(this.tmpDataSource);
   selection = new SelectionModel<any>(false, []);
   isInvalidDragEvent = false;
   constructor(private dialog: MatDialog, private dialogRef: MatDialogRef<ChoiceSetupComponent>, @Inject(MAT_DIALOG_DATA) private data: any,
      public translate: TranslateService, private helperTranslater: HelperTransalaterService) {
         const _fieldGroup = data.field as FormGroup;
         this.choiceType = _fieldGroup.value.type;
   }

   ngOnInit(): void {
      this.initailizeDataSource();
      this.supplyInitsLabels();
      this._setUpDefaultValue();
      this.setPosition();
      this._refreshMatable();
   }

   initailizeDataSource() {
      this.tmpEform = cloneControl<FormArray>(this.data.choice);

      Object.keys(this.tmpEform.at(0).value.label).forEach(v => this.langSupport.push(v));

      Object.keys(this.tmpEform.controls).forEach((_val, index) => {
         const _l = this.tmpEform.controls[_val];
         this.createRows(_l.value.label, _l.value.value, index, _l.value.isPrompt);
      });
      moveItemInArray(this.langSupport, this.langSupport.findIndex(v => v === this.original), 0);
   }

   setPosition() {
      const _menu = this.displayedColumns.findIndex(v => v === 'menu');
      moveItemInArray(this.displayedColumns, _menu, this.displayedColumns.length - 1);
   }

   createRows(data: FormControl, val: string, index: number, promptValue) {
      const _data = data;
      const _dataArrayLabel = [];
      const _preArray = (value: any, lang: string) => {
         const _prepare = value;
         Object.assign(_prepare, { lang: lang, index: index,
             isPrompt : promptValue, validMain: true , validValue: true});
         return _prepare;
      };
      _dataArrayLabel.push(_preArray(_data, val));
      _dataArrayLabel.forEach(v => {
         this.tmpDataSource.push(v);
      });
   }

   supplyInitsLabels() {
      const _notDuplicated = (check) => this.displayedColumns.some(v => v === check);
      const _notCommon = (s) => s !== 'index' && s !== 'isPrompt' && s !== 'validMain'
                             && s !== 'validValue';
      for (const [lang, value] of Object.entries(this.tmpDataSource)) {
         this.tmpDataSource.forEach(v => {
            Object.keys(v).forEach(s => {
               if (value[s] !== '' && !_notDuplicated(s) && _notCommon(s)) {
                  this.displayedColumns.push(s);
                  return;
               }
            });
         });
      }
      if (!_notDuplicated(this.data.eForm.controls.original.value)) {
         this.displayedColumns.push(this.data.eForm.controls.original.value);
      }
      const _index = this.displayedColumns.findIndex(v => v === this.original);
      moveItemInArray(this.displayedColumns, _index, 2);
   }

   addNewLang(number) {
      this.setEdit();
      this.displayedColumns.push('temp' + number);
      this.setPosition();
   }

   check(): boolean {
      return this.langSupport.length <= (this.displayedColumns.length - 3);
   }

   localName(lid: string) {
      let _text;
      this.translate.get('eform.lang').subscribe(v => {
         _text = v[lid];
      });


      return _text;
   }

   selectLangs(newColumn: string, oldColumn, cId) {
      let _newIndex;
      _newIndex = newColumn.startsWith('temp') ? 'temp' + this._dynamicIndex++ : newColumn;

      this.displayedColumns[cId] = _newIndex;
      this.dataSource.data.forEach(v => {
         v[_newIndex] = v[oldColumn];
         v[oldColumn] = '';
      });
      this._sortOriginal();
      this.setEdit();
   }

   checkErrors(_value: string) {
      return  _value === '' ? true : false;
   }

   checkDuplicate(_value: string) {
      const valueArr = this.dataSource.data.map((item) => item.lang) as Array<string>;
      const isDuplicate = valueArr.some((item, idx) => {
         const _tmp = valueArr.filter(v => v === _value);
         if (_tmp.length >= 2) {
            return true;
         } else {
            return false;
         }
      });
      return _value !== '' ? isDuplicate : false;
   }

   resetValue(resetLang: string) {
      this.dataSource.data.forEach(obj => {
         for (const key in obj) { if (key === resetLang) { obj[key] = ''; } }
      });
      this.setEdit();
   }

   duplicateRow(langKey, _index) {
      const _indexTemp = _index + 1;
      const _sourceTemp = [];
      const _pushTemp = (obj: Object) => {
         for (const key in obj) {
            if (key === langKey) {
               _sourceTemp.push(obj[key] === '' ? '' : obj[key]);
            }
         }
      };
      this.duplicateType = langKey;
      let _displayIndex;
      _displayIndex = 'temp' + this.displayedColumns.length;
      this.displayedColumns.splice(_indexTemp, 0, _displayIndex);
      this.dataSource.data.forEach(obj => _pushTemp(obj));

      this._duplicateRow(_displayIndex, _sourceTemp);
      this.setEdit();
   }

   private _duplicateRow(langKey: string, obj: Array<string>) {
      const _reAssign = (index2, v2) => {
         obj.forEach((v, index) => {
            if (index2 === index) { v2[langKey] = v; }
         });
      };
      this.dataSource.data.forEach((v2, index2) => _reAssign(index2, v2));
   }

   setEdit() {
      if (!this.isEdit) { this.isEdit = true; }
   }

   canSelection(value: string): boolean {
      return this.displayedColumns.some(v => v === value);
   }

   addRows(index?) {
      const _val = {};
      const reOrder = () => {
         this.dataSource.data.forEach((v, i) => {
            v.index = i;
         });
      };

      Object.keys(this.dataSource.data[0]).forEach(key => {
            let _tmp: Object = {};
            switch (key) {
               case 'index' :  _tmp = {[key]: index + 1 }; break;
               case 'isPrompt' :
               case 'validMain' :
               case 'validValue' : _tmp = {[key]: false}; break;
               default: _tmp = {[key]: ''}; break;
            }
            Object.assign(_val, _tmp);
      });
      if (index !== '' && index !== undefined) {
         this.dataSource.data.splice(index + 1, 0, _val);
      } else {
         this.dataSource.data.push(_val);
      }
       reOrder();
       this._renderSource();
       setTimeout(() => { this.divs.last.nativeElement.focus(); }, 500);
   }

   deleteRow(index) {
      this.dataSource.data.splice(index, 1);
      if (this.defaultValue !== null && this.defaultValue !== undefined) {
         this.defaultValue = this.defaultValue.index === index ? null : this.defaultValue;
      }
      this._renderSource();
   }

   drop(event: CdkDragDrop<any[]>) {
      moveItemInArray(this.dataSource.data, event.previousIndex, event.currentIndex);
      const findIndexPromp = () => {
         const index = this.dataSource.data.findIndex(v => v.isPrompt);
         moveItemInArray(this.dataSource.data, index, 0);
      };
      findIndexPromp();
      this._renderSource();
      this.setEdit();
   }

   dragStarted() {
      if (this.isInvalidDragEvent) {
         document.dispatchEvent(new Event('mouseup'));
      }
   }

   onInvalidDragEventMouseDown(b) {
      this.isInvalidDragEvent = b;
   }

   checkbox(row, event) {
      setTimeout(() => {
        if (event) {
         this.defaultValue = row;
        } else {
         this.defaultValue = null;
        }
      }, 50);
   }

   containingTmp() {
      let _boolean = false;
      this.displayedColumns.forEach(v => {
         if (v.startsWith('temp')) {
            _boolean = true;
         }
      });
      return _boolean;
   }

   save(): void {
      const data = {
         message: this.helperTranslater.getTagEform('msg.aware-containing-cancel-save'),
         ok: {
            color: 'primary',
            label: this.helperTranslater.getTagEform('button.yes'),
            action: () => this._ok()
         },
         close: {
            label: this.helperTranslater.getTagEform('button.no'),
            action: () => true
         }
      };
      this.containingTmp() ? this.dialog.open(MessageBoxComponent, { disableClose: true, data }) : this._ok();
   }

   saveSetup() {
      const _field = this.data.field as FormGroup;
      const _choices  =  _field.controls.choices as FormArray;
      const prepare = (value, label) => {
         const _tmp =  new FormGroup({
            'isPrompt': new FormControl(label.isPrompt),
            'value': new FormControl(value),
            'label': new FormGroup({
               'th' : new FormControl(label.th),
               'en' : new FormControl(label.en),
               'cn' : new FormControl(label.cn),
            }),
         });
         _choices.push(_tmp);
      };
      _choices.clear();
      this.dataSource.data.forEach(v => {
         prepare(v.lang, v);
      });

      this._saveDefault(_field);
      this.close();
   }

   private _saveDefault(_field: FormGroup) {
      const _val = (this.defaultValue === null || this.defaultValue === undefined) ? -1 : this.defaultValue.lang;
      _field.controls.choiceDefaultValue.setValue(_val);
   }

   deleteActions(column): void {
      const data = {
         message: this.helperTranslater.getTagEform('msg.aware-delete-column'),
         ok: {
            color: 'primary',
            label: this.helperTranslater.getTagEform('button.yes'),
            action: () => this._deleteAction(column)
         },
         close: {
            label: this.helperTranslater.getTagEform('button.no'),
            action: () => true
         }
      };
      this.dialog.open(MessageBoxComponent, { disableClose: true, data });
   }

   close() {
      this.dialogRef.close('send back');
   }

   cancel(): void {
      const data = {
         message: this.helperTranslater.getTagEform('msg.aware-cancel-save'),
         ok: {
            color: 'primary',
            label: this.helperTranslater.getSingleTranslation('create_tasks.save'),
            action: () => this._ok()
         },
         close: {
            label: this.helperTranslater.getTagEform('button.dont-save'),
            action: () => this._close()
         }
      };
      this.isEdit && !this.canSave() && this._isDuplicate() ? this.dialog.open(MessageBoxComponent, { disableClose: true, data }) : this._close();
   }

   _ok() {
      this.saveSetup();
      return true;
   }

   _close() {
      this.dialog.closeAll();
      return true;
   }

   openEditDialog(column) {
     const _obj = this.dataSource.data.map(v => v[column]);
     const _dialog =  this.dialog.open(EditDialogComponent, { disableClose: true, data: _obj});
     const _mustbeAddMore = (_source, _target) => {
        if (_source < _target) {
           let _count = _target - _source;
           while (_count !== 0) {
            this.addRows();
            _count--;
           }
        }
     };
     _dialog.afterClosed().subscribe(v => {
        if (v) {
         _mustbeAddMore(this.dataSource.data.length, v.length);
         v.forEach((_val, index) => {
            this.dataSource.data.forEach((_val2, index2) => {
               if (index === index2) {
                  _val2[column] = _val;
               } else if (index < index2) {
                  _val2[column] = '';
               }
            });
         });
        }
     });
   }

   addPrompt(event) {
      const key = [];
      const tempPrompt = { lang: '', index: 8001, isPrompt: true, validMain: true, validValue: true};
      const notCommon = (v: string) => v !== 'lang' && v !== 'select' &&
         v !== 'menu' && !v.startsWith('temp');

      if (event.checked) {
         this.displayedColumns.forEach(v => {
            if (notCommon(v)) {
               key.push(v);
            }
         });

         key.forEach((responseKey) => {
            let text = '';
            switch (responseKey) {
               case 'th': text = '--- กรุณาเลือก ---'; break;
               case 'en': text = '--- Please Select ---'; break;
               case 'cn': text = '--- Please Select ---'; break;
            }
            Object.assign(tempPrompt, { [responseKey]: text });
         });
         this.dataSource.data.unshift(tempPrompt);
      } else {
         this.dataSource.data.shift();
      }
      this._renderSource();
      this.activePrompt();
      this.setEdit();
   }

   activePrompt() {
      return  this.dataSource.data.findIndex(v => v.isPrompt);
   }

   checkValidator(item, value, active, type) {
      if (active) {
         if (type === 'main') {
            item.validMain = value === '' ? false : true;
         } else {
            const noValue = value === '' ? false : true;
            let duplicate = true;
            if (this.checkDuplicate(value)) {
               duplicate = false;
            }
            item.validValue = noValue;
         }
      }
   }

   _isDuplicate() {
      const _list = [];
      this.dataSource.data.forEach(v => _list.push(v.lang));
      const findDuplicates = arr => arr.filter((itemx, index) => arr.indexOf(itemx) !== index);
      return findDuplicates(_list).length === 0;
   }

   canSave() {
      const y = this.dataSource.data.some((item) => !item.validMain);
      const x = this.dataSource.data.some((item) => !item.validValue);
      return y || x ;
   }

   private _setUpDefaultValue() {
      const _array = this.dataSource.data.find(v => {
         return v.lang === this.defaultValue.toString();
      });
      this.defaultValue = _array;
   }

   private _renderSource() {
      this.dataSource.data = [...this.dataSource.data];
   }

   private _sortOriginal(): void {
      const _index1 = this.displayedColumns.findIndex(v => v === this.original);
      if (_index1 !== -1) { moveItemInArray(this.displayedColumns, _index1, 2); }
   }

   private _deleteAction(resetLang: string) {
      this.resetValue(resetLang);
      this.displayedColumns.splice(this.displayedColumns.indexOf(resetLang), 1);
      this.setEdit();
      return true;
   }

   private _refreshMatable() {
      setTimeout(() => {
         this.dataSource.data.push({items: 'tmpRow'});
         this._renderSource();

         this.dataSource.data.pop();
         this._renderSource();
      }, 200);

   }


}
